export default __webpack_public_path__ + "static/media/star.0b3603aa.svg";